<template>
  <div style="height:600px; overflow-y:auto; padding:16px;">
    <Form :model="resourceItem" ref="formValidate" :label-width="150">
      <!--<FormItem label="资源类型：" prop="resourceType">{{resourceItem.resourceType|ResourceType}}</FormItem> -->
      <FormItem label="资源类型：" prop="resourceTypeM2Ms">
        <!-- {{ resourceItem.resourceTypeNames }} -->

        <div
          class="margin-bottom-10"
          v-for="item in resourceItem.resourceTypeM2Ms"
          :key="item.id"
        >
          {{ item.resourceTypeNames }}
        </div>
      </FormItem>

      <FormItem label="资源方等级：" prop="providerLevel">
        {{ resourceItem.providerLevel | ProviderLevel }}
      </FormItem>
      <FormItem label="公司（团队）名称：" prop="companyName">
        {{ resourceItem.companyName }}
      </FormItem>
      <FormItem label="组织类型：">{{ resourceItem.groupType }}</FormItem>
      <!-- <FormItem label="采集类型：" prop="collectType">
        {{ resourceItem.collectType }}
      </FormItem>
      <FormItem label="标注类型：" prop="markType">
        {{ resourceItem.markType }}
      </FormItem> -->
      <FormItem label="地址：" prop="address">
        {{ resourceItem.address }}
      </FormItem>
      <FormItem label="项目区域：" prop="regions">
        {{ resourceItem.regions }}
      </FormItem>
      <!-- <FormItem label="甲方客户(做过哪些甲方的数据)：" prop="partyA">
        {{ resourceItem.partyA }}
      </FormItem>
      <FormItem label="甲方项目：" prop="partyAProject">
        {{ resourceItem.partyAProject }}
      </FormItem> -->
      <FormItem
        v-for="(item, index) in resourceItem.partyAProjects"
        :label="'甲方项目' + (index + 1) + '：'"
        :key="item.id"
      >
        {{ item.name }}
      </FormItem>

      <FormItem label="能力：" prop="ability">
        {{ resourceItem.ability }}
      </FormItem>
      <FormItem label="规模：" prop="scale">
        全职人数：【{{ resourceItem.fullTime }}】 | 兼职人数：【{{
          resourceItem.partTime
        }}】
      </FormItem>
      <FormItem
        label="联系人："
        v-for="item in resourceItem.contacts"
        :key="item.id"
      >
        <Row class="margin-top-10">
          姓名：{{ item.name }}
          <span v-if="item.phone" class="margin-left-10">
            固话：{{ item.phone }}
          </span>
          <span v-if="item.mobile" class="margin-left-10">
            手机：{{ item.mobile }}
          </span>
        </Row>
        <Row class="margin-top-10">
          <span v-if="item.wechat" class="margin-right-10">
            微信：{{ item.wechat }}
          </span>
          <span v-if="item.email" class="margin-right-10">
            邮箱：{{ item.email }}
          </span>
          <span v-if="item.qq">qq：{{ item.qq }}</span>
        </Row>
        <Row class="margin-top-10">
          <span v-if="item.otherContact">其它：{{ item.otherContact }}</span>
        </Row>
      </FormItem>
      <FormItem label="与公司或员工关系：" prop="relationship">
        {{ resourceItem.relationshipKnow }} {{ resourceItem.relationship }}
      </FormItem>
      <!-- <FormItem label="与公司合作过的任务：">
        {{ resourceItem.oldjob }}
      </FormItem> -->
      <FormItem
        v-for="(item, index) in resourceItem.cooperations"
        :label="'参与公司合作项目' + (index + 1) + '：'"
        :key="item.id"
      >
        {{ item.name }}
      </FormItem>
      <FormItem
        v-for="(item, index) in resourceItem.assessments"
        :label="'参与公司评估项目' + (index + 1) + '：'"
        :key="item.id"
      >
        {{ item.name }}
      </FormItem>
    </Form>
    <Divider v-if="resourceItem.blackListType">黑名单原因</Divider>
    <Row v-if="resourceItem.blackListType">
      黑名单类型： {{ resourceItem.blackTypeString }}
    </Row>
    <Row v-if="resourceItem.blackListType">
      {{ resourceItem.blackListReason }}
    </Row>

    <Divider>评论</Divider>

    <div>
      <Row
        type="flex"
        class="margin-top-10"
        v-for="item in commentList"
        :key="item.id"
      >
        <Col span="2">{{ item.userName }}：</Col>
        <Col span="16">{{ item.content }}</Col>
        <Col span="4">{{ item.time }}</Col>
        <Col span="2">
          <a
            v-if="item.entryUserId == $store.state.user.userId"
            @click="deleteComment(item.id)"
          >
            删除
          </a>
        </Col>
      </Row>
      <Row class="margin-top-10">
        <Input
          v-model="commentContent"
          type="textarea"
          :rows="4"
          placeholder="在此处输入评论..."
        />
      </Row>
      <Row class="margin-top-10">
        <Button type="primary" long @click="saveComment">发表评论</Button>
      </Row>
    </div>
  </div>
</template>
<script>
import comment from "@/api/comment.js";
export default {
  data() {
    return {
      resourceItem: {},
      commentContent: "",
      commentList: [],
    };
  },
  filters: {
    ResourceType: function(value) {
      switch (value) {
        case 0:
          return "采集";
        case 1:
          return "标注";
        case 2:
          return "采集和标注";
      }
    },
    ProviderLevel: function(value) {
      switch (value) {
        case 0:
          return "优选";
        case 1:
          return "一般";
        case 2:
          return "登记备用";
      }
    },
  },
  methods: {
    getComment() {
      comment.list({ resourceId: this.resourceItem.id }).then((res) => {
        this.commentList = res.data;
      });
    },
    getData() {
      return this.resourceItem;
    },
    setData(data) {
      this.resourceItem = data;
      this.getComment();
    },
    saveComment() {
      comment
        .add({
          content: this.commentContent,
          resourceId: this.resourceItem.id,
        })
        .then((res) => {
          this.$Message.success("保存成功");
          this.commentContent = "";
          this.getComment();
        });
    },
    deleteComment(id) {
      comment.delete({ id: id }).then((res) => {
        this.$Message.success("删除成功");
        this.getComment();
      });
    },
  },
};
</script>
